var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3934 10.9967L15.156 8.00595L19.9068 15.4053L19.909 16.8254L19.8935 7.05372C19.8822 6.81478 19.7554 6.59622 19.5531 6.46729L10.9999 1.54755C10.7999 1.4492 10.546 1.45038 10.3464 1.55065C10.3194 1.56424 10.2941 1.57886 10.2699 1.59496L10.2401 1.61371L1.93776 6.42476L1.90557 6.43953C1.86407 6.45843 1.82228 6.4828 1.78285 6.51086C1.62542 6.62368 1.52087 6.79071 1.48705 6.97782C1.48203 7.00617 1.47819 7.03512 1.47656 7.06436L1.48956 15.0273L5.91472 8.16869C6.47176 7.25929 7.68568 6.96615 8.8126 6.98225L10.1351 7.0171L2.34255 19.514L3.2611 20.0429L11.1469 7.0298L14.6326 7.0171L6.76712 20.3586L10.0448 22.244L10.4365 22.4691C10.6022 22.5364 10.7974 22.5398 10.9644 22.4794L19.6378 17.4531L17.9796 18.414L13.3934 10.9967ZM14.0658 20.6822L10.7553 15.4861L12.7763 12.0568L17.1241 18.9097L14.0658 20.6822Z",
  fill: "#2D374B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7538 15.486L14.0645 20.682L17.1226 18.9097L12.7748 12.0566L10.7538 15.486Z",
  fill: "#28A0F0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.908 16.8253L19.9057 15.4052L15.155 8.00586L13.3924 10.9966L17.9787 18.4139L19.637 17.4529C19.7996 17.3209 19.8981 17.127 19.9084 16.9179L19.908 16.8253Z",
  fill: "#28A0F0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 18.1645L2.34173 19.5138L10.1342 7.01691L8.81178 6.98206C7.685 6.96611 6.47109 7.2591 5.9139 8.1685L1.48874 15.0271L0 17.3145V18.1645Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6312 7.0166L11.1456 7.0293L3.25977 20.0424L6.01617 21.6293L6.76563 20.3581L14.6312 7.0166Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3769 6.99904C21.3478 6.2701 20.9531 5.60289 20.3349 5.21435L11.6696 0.231116C11.0581 -0.0767924 10.2942 -0.0772354 9.68145 0.230968C9.60909 0.267445 1.25467 5.11275 1.25467 5.11275C1.13904 5.16813 1.02769 5.23414 0.922985 5.30916C0.371114 5.70479 0.0347043 6.31943 0 6.99461V17.3148L1.48874 15.0274L1.47574 7.06431C1.47752 7.03522 1.48121 7.00642 1.48623 6.97822C1.5199 6.79081 1.6246 6.62379 1.78203 6.51082C1.82146 6.48276 10.3184 1.5642 10.3454 1.55062C10.5452 1.45034 10.7989 1.44916 10.9989 1.54752L19.5521 6.46725C19.7544 6.59617 19.8813 6.81474 19.8925 7.05368V16.9178C19.8821 17.1269 19.7994 17.3208 19.6368 17.4529L17.9786 18.4138L17.1229 18.9097L14.0648 20.682L10.9634 22.4792C10.7964 22.5396 10.601 22.5362 10.4355 22.4689L6.76615 20.3584L6.01654 21.6296L9.31418 23.5282C9.42316 23.5902 9.52034 23.6451 9.60008 23.69C9.72354 23.7593 9.80772 23.8055 9.8374 23.82C10.0718 23.9338 10.4089 24 10.7128 24C10.9914 24 11.2631 23.9489 11.5202 23.8482L20.5284 18.6315C21.0454 18.2308 21.3496 17.6267 21.3769 16.9723V6.99904Z",
  fill: "#96BEDC"
});

function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.ffea612ae09ec17c78fb7d9f7190aee6.svg";
export { ForwardRef as ReactComponent };